import React, { FunctionComponent, ReactElement } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import SmallTeaserHeadlineFont from '../../../Theme/Fonts/SmallTeaserHeadline'
import SmallButton from '../../../BaseComponents/Button/Standard/Small'

type Props = {
    infoText: string
    buttonText: string
    onPress: () => void
    marginTop: number
    marginBottom: number
}

const ErrorWarningSmall: FunctionComponent<Props> = ({
    infoText,
    buttonText,
    onPress,
    marginBottom,
    marginTop,
}): ReactElement => {
    return (
        <Grid noExpand centerHorizontal marginX={8} backgroundColor="BLACK">
            <FontelloIcon name="info-active" fontSize={30} color="WHITE" />
            <Grid noExpand marginTop={marginTop} marginBottom={marginBottom}>
                <SmallTeaserHeadlineFont color="WHITE" textAlign="center">
                    {infoText}
                </SmallTeaserHeadlineFont>
            </Grid>
            <SmallButton onPress={onPress} backgroundColor="WHITE">
                {buttonText}
            </SmallButton>
        </Grid>
    )
}

export default ErrorWarningSmall
